export function PrivacyNotice() {
  return (
    <section className="bg-surface-low rounded-4 p-3 d-flex align-items-center gap-3 mt-3">
      <div
        className="rounded-circle bg-surface-highest d-flex align-items-center justify-content-center text-primary flex-shrink-0"
        style={{ width: 36, height: 36 }}
      >
        <i className="bi bi-shield-lock" style={{ fontSize: 16 }} />
      </div>
      <p className="text-body-sm text-on-surface-variant mb-0">
        <span className="text-label-sm text-on-surface">End-to-end encrypted.</span> Files are streamed
        into an encrypted sandbox and permanently wiped from this kiosk once printing completes.
      </p>
    </section>
  );
}
